/**
 * PDP Offer Selector — single source of truth: #pdp-selected-variant (hidden input).
 * Offer card click → set value on #pdp-selected-variant + active class + hide error.
 * Add to cart → read from #pdp-selected-variant, POST /cart/add.js, then open cart drawer (no redirect).
 */
(function() {
  'use strict';

  var DEBUG = window.__DEBUG_OFFER_SELECTOR === true;
  var OFFER_1_VARIANT = '44041237858339';
  var OFFER_2_VARIANT = '44041237889107';

  function debugLog() {
    if (console && console.log) {
      console.log.apply(console, ['[PDP Offer Selector]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var containers = document.querySelectorAll('div[id^="pdp-offer-selector-"]');
    for (var i = 0; i < containers.length; i++) {
      setupOfferSelector(containers[i]);
    }
  }

  function getVariantIdForOffer(container, offerType) {
    var v1 = (container.dataset.variantOffer1 || '').toString().trim();
    var v2 = (container.dataset.variantOffer2 || '').toString().trim();
    var hidden = container.querySelector('#pdp-selected-variant');
    if (hidden) {
      if (!v1 && hidden.getAttribute('data-offer-1')) v1 = hidden.getAttribute('data-offer-1').trim();
      if (!v2 && hidden.getAttribute('data-offer-2')) v2 = hidden.getAttribute('data-offer-2').trim();
    }
    if (!v1) v1 = OFFER_1_VARIANT;
    if (!v2) v2 = OFFER_2_VARIANT;
    return offerType === 'offer_2' ? v2 : v1;
  }

  function getQuantityForOffer(container, offerType) {
    var q1 = parseInt(container.dataset.quantityOffer1 || '1', 10) || 1;
    var q2 = parseInt(container.dataset.quantityOffer2 || '2', 10) || 2;
    return offerType === 'offer_2' ? q2 : q1;
  }

  function setSelectedVariantId(container, variantId) {
    container.setAttribute('data-selected-variant-id', variantId || '');
    var hidden = container.querySelector('#pdp-selected-variant, input[name="id"]');
    if (hidden) hidden.value = variantId || '';
  }

  function setSelectedQuantity(container, quantity) {
    var q = Math.max(1, parseInt(quantity, 10) || 1);
    container.setAttribute('data-selected-quantity', String(q));
    container.setAttribute('data-selected-qty', String(q));
    var hidden = container.querySelector('#pdp-selected-quantity, #pdp-selected-qty');
    if (hidden) hidden.value = String(q);
    var allQty = container.querySelectorAll('#pdp-selected-quantity, #pdp-selected-qty');
    for (var h = 0; h < allQty.length; h++) allQty[h].value = String(q);
  }

  function getSelectedQuantity(container) {
    var hidden = container.querySelector('#pdp-selected-quantity, #pdp-selected-qty');
    if (hidden && hidden.value) return Math.max(1, parseInt(hidden.value, 10) || 1);
    var data = container.getAttribute('data-selected-quantity') || container.getAttribute('data-selected-qty');
    if (data) return Math.max(1, parseInt(data, 10) || 1);
    var activeCard = container.querySelector('.pdp-offer-card.is-active');
    if (activeCard) return getQuantityForOffer(container, activeCard.dataset.offer);
    return 1;
  }

  function getSelectedVariantId(container) {
    var hidden = container.querySelector('#pdp-selected-variant, input[name="id"]');
    if (hidden && hidden.value) return hidden.value.trim();
    var data = container.getAttribute('data-selected-variant-id');
    if (data) return data.trim();
    var activeCard = container.querySelector('.pdp-offer-card.is-active');
    if (activeCard) return getVariantIdForOffer(container, activeCard.dataset.offer);
    return null;
  }

  function updateCtaLabel(container, baseLabel) {
    var activeCard = container.querySelector('.pdp-offer-card.is-active');
    var priceEl = activeCard ? activeCard.querySelector('.pdp-offer-card__price, .pdp-offer-card__current-price') : null;
    var price = priceEl ? priceEl.textContent.trim() : '';
    var addBtns = container.querySelectorAll('.pdp-offer-add-btn, .pdp-add-to-cart-btn');
    for (var b = 0; b < addBtns.length; b++) {
      var textEl = addBtns[b].querySelector('.pdp-offer-add-btn__text, .pdp-add-to-cart-btn__text');
      if (textEl) textEl.textContent = price ? baseLabel + ' — ' + price : baseLabel;
    }
  }

  function hideError(container) {
    var el = container.querySelector('.pdp-offer-error-message');
    if (el) {
      el.style.display = 'none';
      el.textContent = '';
    }
  }

  function setupOfferSelector(container) {
    hideError(container);

    var defaultActive = (container.dataset.defaultActive || 'offer_1').trim();
    var cards = container.querySelectorAll('.pdp-offer-card');
    var benefits = container.querySelectorAll('.pdp-offer-benefit-pill, .pdp-offer-benefit');
    var addToCartBtn = container.querySelector('.pdp-offer-add-btn, .pdp-add-to-cart-btn');
    if (!addToCartBtn) return;

    var btnText = addToCartBtn.querySelector('.pdp-offer-add-btn__text, .pdp-add-to-cart-btn__text');
    var btnLoading = addToCartBtn.querySelector('.pdp-offer-add-btn__loading, .pdp-add-to-cart-btn__loading');
    var btnSuccess = addToCartBtn.querySelector('.pdp-offer-add-btn__success, .pdp-add-to-cart-btn__success');
    var btnError = addToCartBtn.querySelector('.pdp-offer-add-btn__error, .pdp-add-to-cart-btn__error');
    var errorMessage = container.querySelector('.pdp-offer-error-message');
    var baseAddLabel = addToCartBtn.dataset.label || addToCartBtn.getAttribute('data-label') || 'Add to cart';
    var isSubmitting = false;

    function setActiveOffer(offerType) {
      for (var c = 0; c < cards.length; c++) {
        if (cards[c].dataset.offer === offerType) {
          cards[c].classList.add('is-active');
          cards[c].setAttribute('aria-selected', 'true');
        } else {
          cards[c].classList.remove('is-active');
          cards[c].setAttribute('aria-selected', 'false');
        }
      }
      for (var j = 0; j < benefits.length; j++) {
        benefits[j].classList.toggle('is-hidden', benefits[j].dataset.offer !== offerType);
      }
      var variantId = getVariantIdForOffer(container, offerType);
      var quantity = getQuantityForOffer(container, offerType);
      setSelectedVariantId(container, variantId);
      setSelectedQuantity(container, quantity);
      updateCtaLabel(container, baseAddLabel);
      hideError(container);
      debugLog('offer selected:', offerType, 'selected_variant_id:', variantId, 'selected_quantity:', quantity);
    }

    setActiveOffer(defaultActive);

    // Disable main product form quantity selector so offer logic is not broken
    var section = container.closest('.product-section, [data-section-id], .thb-product-detail');
    if (section) {
      var qtyInputs = section.querySelectorAll('input[name="quantity"]');
      for (var q = 0; q < qtyInputs.length; q++) {
        if (!container.contains(qtyInputs[q])) {
          qtyInputs[q].disabled = true;
          qtyInputs[q].setAttribute('aria-hidden', 'true');
          var wrap = qtyInputs[q].closest('.product-form__input--quantity, .quantity-selector, .add_to_cart_holder, .product-add-to-cart-container');
          if (wrap) wrap.style.display = 'none';
        }
      }
    }

    for (var i = 0; i < cards.length; i++) {
      (function(card) {
        card.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var offerType = card.dataset.offer;
          setActiveOffer(offerType);
        });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setActiveOffer(card.dataset.offer);
          }
        });
      })(cards[i]);
    }

    function openCartDrawerOrRedirect(sections) {
      if (sections && sections['cart-bubble']) {
        var bubble = document.getElementById('cart-drawer-toggle');
        if (bubble) {
          try {
            var parser = new DOMParser();
            var doc = parser.parseFromString(sections['cart-bubble'], 'text/html');
            var countEl = doc.querySelector('.thb-item-count') || doc.querySelector('[class*="item-count"]');
            var target = bubble.querySelector('.thb-item-count') || bubble;
            if (countEl && target) target.innerHTML = countEl.innerHTML;
          } catch (err) {}
        }
      }
      var cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer && sections && sections['cart-drawer']) {
        try {
          var parser = new DOMParser();
          var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var inner = doc.querySelector('.cart-drawer') || doc.querySelector('.shopify-section');
          if (inner) {
            var target = cartDrawer.querySelector('.cart-drawer') || cartDrawer;
            target.innerHTML = inner.innerHTML;
          }
          if (typeof cartDrawer.notesToggle === 'function') cartDrawer.notesToggle();
          if (typeof cartDrawer.removeProductEvent === 'function') cartDrawer.removeProductEvent();
          cartDrawer.classList.add('active');
          document.body.classList.add('open-cart');
          document.body.classList.add('open-cc');
          var recs = cartDrawer.querySelector('.product-recommendations--full');
          if (recs) recs.classList.add('active');
          if (typeof window.dispatchCustomEvent === 'function') {
            window.dispatchCustomEvent('cart-drawer:open');
          } else {
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          }
          return;
        } catch (err) {}
      }
      window.location.href = '/cart';
    }

    function fetchSectionsAndOpenDrawer() {
      var sectionsParam = 'cart-drawer,cart-bubble';
      var url = (window.location.pathname || '/') + '?sections=' + sectionsParam;
      fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(text) {
          var sections;
          try {
            sections = JSON.parse(text);
          } catch (e) {
            debugLog('fetchSectionsAndOpenDrawer: failed to parse sections response');
            openCartDrawerOrRedirect(null);
            return;
          }
          openCartDrawerOrRedirect(sections);
        })
        .catch(function(err) {
          debugLog('fetchSectionsAndOpenDrawer error:', err);
          openCartDrawerOrRedirect(null);
        });
    }

    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (isSubmitting) return;

      var variantId = getSelectedVariantId(container);
      if (!variantId) {
        if (errorMessage) {
          errorMessage.textContent = 'Please select an offer.';
          errorMessage.style.display = 'block';
          setTimeout(function() { hideError(container); }, 3000);
        }
        return;
      }

      hideError(container);
      isSubmitting = true;
      if (btnText) btnText.style.display = 'none';
      if (btnLoading) btnLoading.style.display = 'inline';
      if (btnError) btnError.style.display = 'none';
      addToCartBtn.disabled = true;

      var quantity = getSelectedQuantity(container);
      var variantIdNum = parseInt(variantId, 10);
      var payload = { items: [{ id: variantIdNum, quantity: quantity }] };

      debugLog('add-to-cart payload:', JSON.stringify(payload));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var lineCount = (data.items && data.items.length) ? data.items.length : (data.id ? 1 : 0);
          debugLog('add-to-cart response, line items count:', lineCount, data);
          if (data.status && data.status !== 200) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          }
          if (btnSuccess) { btnSuccess.style.display = 'inline'; }
          if (btnLoading) btnLoading.style.display = 'none';
          if (typeof window.dispatchCustomEvent === 'function') {
            window.dispatchCustomEvent('cart:item-added', { product: data.items ? data.items[0] : data });
          } else {
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: data.items ? data.items[0] : data } }));
          }
          if (data.sections) {
            openCartDrawerOrRedirect(data.sections);
          } else {
            fetchSectionsAndOpenDrawer();
          }
          setTimeout(function() {
            if (btnSuccess) btnSuccess.style.display = 'none';
            if (btnText) btnText.style.display = 'inline';
            isSubmitting = false;
            addToCartBtn.disabled = false;
          }, 1500);
        })
        .catch(function(err) {
          debugLog('add-to-cart error:', err);
          if (btnLoading) btnLoading.style.display = 'none';
          if (btnText) btnText.style.display = 'inline';
          if (errorMessage) {
            errorMessage.textContent = err.message || 'Could not add to cart. Try again.';
            errorMessage.style.display = 'block';
            setTimeout(function() { hideError(container); }, 5000);
          }
          if (btnError) {
            btnError.style.display = 'inline';
            btnError.textContent = 'Error';
            setTimeout(function() { btnError.style.display = 'none'; }, 3000);
          }
          isSubmitting = false;
          addToCartBtn.disabled = false;
        });
    });

    var form = container.querySelector('.pdp-offer-form-fallback');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        addToCartBtn.click();
        return false;
      });
    }
  }
})();
